import {
  Button,
  Grid,
  Paper,
  Typography,
  Chip,
} from '@material-ui/core';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import handleError from '../../utils/handleError';
import TicketCards from '../../components/Cards/ticketCards';
import RonadIcons from '../../components/iconComponent';
import AddMessage from './components/addMessage';
import { getSingleTicket, getTicketContents } from '../../api/ticket/get';
import { Ticket } from '../../types&interfaces/ticket';
import { Link, RouteProps, useHistory } from 'react-router-dom';
import { translate } from '../../utils/helpers';
import { closeTicket, makeSeenTicket } from '../../api/ticket/update';

const useStyles = makeStyles(theme =>
  createStyles({
    chatHeader: {
      padding: "16px",
      borderBottomLeftRadius: "0",
      borderBottomRightRadius: "0",
    },
    chatBody: {
      padding: "16px",
      borderRadius: "0",
    },
    chatFooter: {
      border: "1px solid #ededed",
      borderTopLeftRadius: "0",
      borderTopRightRadius: "0",
      padding: "16px",
    }
  })
);
const ticketPriority = {
  LOW:   {
    id: 0,
    name: 'LOW',
    title: 'کم',
    color: '#007644',
    bcolor: '#e8faea',
  },
  NORMAL: {
    id: 1,
    name: 'NORMAL',
    title: 'متوسط',
    color: '#FF7E07',
    bcolor: '#ffeedf',
  },
  HIGH: {
    id: 2,
    name: 'HIGH',
    title: 'زیاد',
    color: '#FF0000',
    bcolor: '#fffafa',
  },
  CRITICAL: {
    id: 3,
    name: 'CRITICAL',
    title: 'اضطراری',
    color: 'maroon',
    bcolor: '#fffafa',
  },
}



const TicketDetails = (props: FunctionComponent<RouteProps>) => {
  const ticketId = props.match.params.id
  const [ticketObject, setTicketObject] = useState<Ticket | undefined>(undefined);
  const [contents, setContents] = useState<any[] | undefined>(undefined);
  const history = useHistory()
  const classes = useStyles();

  useEffect(() => {
    getTicketById()
    getContents()
  }, []);
  const getTicketById = async () => {
    try {
      const ticket = await getSingleTicket(ticketId)
      setTicketObject(ticket.data)
      if(ticket.data.seen === "0") {
        await makeSeen(ticket.data)
      }
    } catch (error) {
      handleError(error)
    }
  }
  const getContents = async () => {
    try {
      const ticket = await getTicketContents(ticketId)
      setContents(ticket.data)
    } catch (error) {
      handleError(error)
    }
  }
  const handleClose = async () => {
    try {
      await closeTicket(ticketId)
    } catch (error) {
      handleError(error)
    }
  };

  const makeSeen = async (ticket: Ticket) => {
    if(ticket.assignmentType === 'FFC' && ['OWNER_ANSWERED', 'OPEN'].includes(ticket.status)) {
      return 
    }else if(ticket.assignmentType === 'PARTNER' && ticket.status === 'ASSIGNEE_ANSWERED') {
      return
    }else {
      await makeSeenTicket(ticketId)
    }
  }

  return (
    <React.Fragment>
      <Typography variant="h6" component="h2" style={{marginBottom: "24px"}}>
        <Button onClick={() => history.goBack()}>
          <RonadIcons name='chevronRight' />
        </Button>
        تیکت شماره {ticketObject?.tracking} - <Link
          to={ticketObject?.linkType === 'order' ? `/orders/${ticketObject.linkId}` : `/parcels/details/${ticketObject?.linkId}`}
        >
          {ticketObject?.linkId}
        </Link>
      </Typography>
      <Paper className={classes.chatHeader}>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={1}
        >
          <Grid item md={3} lg={3} style={{ padding: '8px' }}>
            <Typography variant="body1" id="ticketTitle"></Typography>
          </Grid>
          <Grid item md={6} lg={6}>
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              spacing={1}
              alignItems="center"
              style={{ padding: '8px' }}
            >
              <Grid item md={3} lg={3}>
                <Typography variant="subtitle2">
                  وضعیت:
                  {translate(`${ticketObject?.assignee.type}_${ticketObject?.status}`, 'ticket')}
                </Typography>

                {/*insert status data */}
              </Grid>

              <Grid item>
                <Button
                  variant="outlined"
                  size="medium"
                  component="span"
                  color="default"
                  onClick={handleClose}
                  disabled={ticketObject?.status == "CLOSED"}
                >
                  بستن تیکت
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
      <Paper className={classes.chatBody}>
        {contents?.map(el => {
          return <TicketCards data={el} ticketId={ticketId}/>
        })}

      </Paper>
      <Paper className={classes.chatFooter}>
        <AddMessage reloadPage={getContents} id={ticketId}/>
      </Paper>
    </React.Fragment>
  );
};

export default TicketDetails;